import styled, { css } from "styled-components";

import { Card } from "@mui/material";
import Colors from "@src/constants/Colors";

const getNotesTableStyles = (isNotesTable: boolean) =>
  isNotesTable
    ? css`
        border-top-right-radius: 0;
        border-top-left-radius: 0;
      `
    : "";

const getViewModeStyles = (viewMode: boolean) =>
  viewMode
    ? css`
        border-bottom: 16px solid ${Colors.white};
      `
    : "";

export const CustomCard = styled(Card)<{
  $isDataTable: boolean;
  $isNotesTable: boolean;
  $viewMode: boolean;
}>`
  &.MuiPaper-root {
    background: ${Colors.white};
    box-sizing: border-box;
    padding: ${(props) => (props.$isDataTable ? "8px" : "16px")};
    border: 1px solid ${Colors.neutralwhite};
    box-shadow: ${Colors.Elevation_2};
    border-radius: 8px;
    ${(props) => getNotesTableStyles(props.$isNotesTable)}
    ${(props) => getViewModeStyles(props.$viewMode)}
  }
`;
export const CustomCardHeader = styled.div`
  font-family: Ringside Regular-Bold;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.primary};
`;

export const DividerWrapper = styled.div<{
  disableDividerStyle?: boolean;
}>`
  margin-top: ${(props) => (props.disableDividerStyle ? 0 : 8)}px;
`;
